import { MutationHookOptions, useMutation } from '@apollo/client';

import mutation from './bulkAddAssetsMutation.graphql';

export const useBulkAddAssetsMutation = (
  opts?: MutationHookOptions<
    BulkAddAssetsMutation,
    BulkAddAssetsMutationVariables
  >,
) => {
  return useMutation<BulkAddAssetsMutation, BulkAddAssetsMutationVariables>(
    mutation,
    opts,
  );
};
